import { routerReady } from '@/utils/ready';
import QueryString from 'qs';
import Vue from 'vue';
import OPCRouter from './opc-router';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import Bridge from '@/views/bridge';
import { routePathMap } from '@/router/constant';
import { persistCartConstant } from '@/views/config/shopping-cart/persist/persist-cart';
import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';

Vue.use(OPCRouter);

export let routes = [];

export default function routerCreator(i18n) {
  routes = [
    {
      title: persistCartConstant.enablePersistShoppingBag ? i18n.t('billing.common.cart_bag.cart_title') : i18n.t('billing.your_products'),
      name: 'Config',
      path: routePathMap.config,
      component: Bridge,
    },
    {
      title: i18n.t('billing.checkout'),
      path: routePathMap.checkout,
      name: 'CheckOut',
      component: () => import(/* webpackChunkName: "checkout" */ '@/views/checkout'),
    },
    {
      title: 'Edit Current Plan',
      name: 'Edit',
      path: routePathMap.edit,
      component: Bridge,
    },
    {
      //todo define name
      title: 'Add Plan',
      name: 'Add',
      path: routePathMap.add,
      component: Bridge,
    },
    {
      title: 'Downgrade Plan',
      name: 'Downgrade',
      path: routePathMap.downgrade,
      component: Bridge,
    },
    {
      title: 'Upgrade Plan',
      name: 'Upgrade',
      path: routePathMap.upgrade,
      component: Bridge,
    },
    {
      title: 'Update Success',
      name: 'UpdateSuccess',
      path: routePathMap.updateSuccess,
      component: () => import(/* webpackChunkName: "updatesuccess" */ '@/views/success/upgrade'),
    },
    {
      title: 'Add Success',
      name: 'AddTrialSuccess',
      path: routePathMap.addTrialSuccess,
      component: () => import(/* webpackChunkName: "updatesuccess" */ '@/views/success/addTrial'),
    },
    {
      title: 'Success',
      name: 'success',
      path: routePathMap.success,
      component: () => import(/* webpackChunkName: "succezz" */ '@/views/succezz/index.js'),
    },
    {
      title: 'Update Success',
      name: 'ApmSuccess',
      path: routePathMap.apmSuccess,
      component: () => import(/* webpackChunkName: "updatesuccess" */ '@/views/succezz/apm/update'),
    },
  ];

  const router = new OPCRouter({
    mode: 'history',
    base: process.env.VUE_APP_REMOTE_SERVER_ROOT,
    routes: [
      ...routes,
      {
        path: `/`,
        redirect: () => {
          if (
            [flowTypes.pro2biz, flowTypes.edit, flowTypes.mixBuy, flowTypes.biz2bundle, flowTypes.esc2escp].includes(
              pageConfig.type,
            )
          ) {
            return routePathMap.edit;
          }

          if ([flowTypes.add2cart, flowTypes.add2trial].includes(pageConfig.type)) {
            return routePathMap.add;
          }

          if ([flowTypes.prop2bundle, flowTypes.pro2prop, flowTypes.pro2bundle].includes(pageConfig.type)) {
            return routePathMap.upgrade;
          }

          return routes[0].path;
        },
      },
      {
        path: `*`,
        component: {
          created() {
            window.location.href = '/error/404';
          },
        },
      },
    ],
  });

  router.afterEach(() => {
    window.scrollTo(0, 0);

    emit(EVENT_TYPES.URL_CHANGE, location.href);
  });

  const initQuery = QueryString.parse(location.search.slice(1));

  router.addInterceptor((location) => ({
    ...location,
    query: {
      ...initQuery,
      ...location.query,
    },
  }));
  routerReady.solved(router);
  return router;
}
